<div class="content-block">
    <dx-validation-group #validationGroup>
        <div>
            <div class="row">
                <label>Dimensione barcode: </label>
                <dx-select-box [dataSource]="listDimensioni" valueExpr="id" displayExpr="descrizione"
                    [(value)]="dimensione">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-select-box>
            </div>
            <div class="row">
                <label>Numero di copie: </label>
                <dx-number-box [(value)]="numeroCopie" [min]="1">
                    <dx-validator>
                        <dxi-validation-rule type="required" message="">
                        </dxi-validation-rule>
                    </dx-validator>
                </dx-number-box>
            </div>
        </div>
    </dx-validation-group>
    <div class="row">
        <dx-button stylingMode="contained" text="Stampa barcode" icon="print" type="success"
            (onClick)="onStampaClick()">
        </dx-button>
    </div>
</div>